import { render } from "./MovieDetails.vue?vue&type=template&id=34d72594"
import script from "./MovieDetails.vue?vue&type=script&lang=js"
export * from "./MovieDetails.vue?vue&type=script&lang=js"
script.render = render

export default script